<script setup>
import Button from '../global/Button.vue'
</script>

<template>
    <section class="pb-32 bg-gradient-to-t from-carbon-100 to-carbon-200 text-white xl:-mb-48 md:-mb-0 -mb-48">
        <div class="container">
            <div class="grid grid-cols-12 lg:gap-6 gap-y-12">
                <div class="lg:col-span-5 col-span-12 flex flex-col lg:gap-16 gap-8">
                    <p class="lg:text-xl text-sm font-bold uppercase lg:text-left text-center accent-text">Keep Playing</p>
                    <div class="flex flex-col lg:items-start items-center lg:text-left text-center gap-6">
                        <h3 class="lg:text-4xl text-3xl font-bold uppercase">LOGITECH G<br>ADAPTIVE GAMING KIT</h3>
                        <p class="leading-relaxed opacity-75 text-sm">Comprehensive controls for ultimate configurability and flexibility designed in partnership with accessibility organizations.<br><br>Adapt your way! Looking for gear to compete? Logitech G has you covered. The Adaptive Gaming Kit is designed to adapt to your needs.Looking for additional help? We are partnered with <a target="_blank" href="https://ablegamers.org/" class="underline">AbleGamers</a> who specializes in turning impossible to i'm possible.</p>
                        <Button href="https://www.logitechg.com/en-gb/products/gamepads/adaptive-gaming-kit-accessories.html">Logitech G Adaptive Gaming Kit</Button>
                    </div>
                </div>
                <div class="lg:col-span-8 col-span-12 lg:col-start-6 lg:row-span-full grid grid-cols-8 gap-6">
                    <div class="md:col-span-3 col-span-4 md:pt-0 pt-8">
                        <div class="relative w-full pt-[56.25%]">
                            <img src="https://d1f3y6u6f3nh06.cloudfront.net/images/elements/adaptive-one.jpg" class="absolute top-0 left-0 w-full rounded-2xl object-cover">
                        </div>
                    </div>
                    <div class="md:col-span-2 col-span-4 md:col-start-7 md:pt-24">
                         <div class="relative w-full pt-[56.25%]">
                            <img src="https://d1f3y6u6f3nh06.cloudfront.net/images/elements/adaptive-two.jpg" class="absolute top-0 left-0 w-full rounded-2xl object-cover">
                        </div>
                    </div>
                    <div class="col-span-8 md:-mt-12">
                        <img class="w-full" src="https://d1f3y6u6f3nh06.cloudfront.net/images/elements/adaptive-gaming-kit.png" alt="Logitech G Adaptive Gaming Kit">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
